import script from "./trend-chart.vue?vue&type=script&setup=true&lang=js"
export * from "./trend-chart.vue?vue&type=script&setup=true&lang=js"

import "./trend-chart.vue?vue&type=style&index=0&id=2a7e5912&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7e5912"]])

export default __exports__